import React from 'react';

import { useHBPrimeData } from 'hb-redux-store/feature/halalboxPrime/hbPrime.hooks';
import { useInitialData } from 'hb-redux-store/initial.hooks';
import history from 'hb-redux-store/history';
import { MEMBERSHIP_REMOVED } from 'hb-redux-store/constants/halalboxPrime';
import { checkPrimeMemberShipSource } from 'hb-redux-store/util/miscellaneousServices';

import Button from 'components/common/Button/Button';
import Icon from 'components/mweb/Icon/Icon';
import { InterPolationText } from 'components/mweb/MembershipBanner/MembershipBanner';
import { HB_PRIME_ROUTE } from 'components/web-feature/Home/constant';

import './membership-banner.scss';

const showDetails = {
  HOMEPAGE: {
    showModal: false,
    arrowAlignment: false,
  },
  CART: {
    showModal: true,
    arrowAlignment: true,
  },
  SEARCH: {
    arrowAlignment: true,
  },
};

const MembershipInfo = ({
  showModal = () => {},
  membershipDetails = {},
  source,
}) => {
  const {
    membershipTitle = '',
    membershipSubTitle = '',
    cta,
    redirectEnable,
  } = membershipDetails;
  const bannerText = `${membershipTitle} ${membershipSubTitle}`;
  const showArrow = !cta && redirectEnable;
  const showButton = !!cta && redirectEnable;

  const handleRedirection = () => {
    if (!redirectEnable) return;
    if (showDetails[source]?.showModal) {
      showModal();
    } else {
      history.push(HB_PRIME_ROUTE);
    }
  };

  return (
    <>
      <div className={`${cta ? 'desktop-membership-banner--info-width' : ''}`}>
        <InterPolationText banner={membershipDetails} bannerText={bannerText} />
      </div>
      {showArrow && (
        <div
          className="desktop-membership-banner--arrow-container"
          onClick={() => handleRedirection()}
        >
          <Icon class="icon-common-white-arrow-right" size={10} />
        </div>
      )}

      {showButton && (
        <div className="desktop-membership-banner--button-container">
          <Button
            className="desktop-membership-banner--button"
            onClick={() => handleRedirection()}
          >
            {cta}
          </Button>
        </div>
      )}
    </>
  );
};

const MembershipAdded = ({ showModal = () => {}, membershipDetails = {} }) => {
  const {
    membershipTitle = '',
    cta,
    redirectEnable,
    retailPrice,
    salePrice,
    saleOn,
  } = membershipDetails;
  const showChangePlan = !!cta && redirectEnable;
  const onSale = saleOn && salePrice < retailPrice;

  const { removeMembershipTocart } = useHBPrimeData();
  const { setAppNotification } = useInitialData();

  const removeMembershipFromCart = () => {
    if (membershipDetails?.hbMembershipId) {
      const payload = {
        api: {
          hbMembershipId: membershipDetails?.hbMembershipId,
          isBuyNow: false,
        },
        successCb: () => setAppNotification(MEMBERSHIP_REMOVED),
      };
      removeMembershipTocart(payload);
    }
  };
  return (
    <>
      <div className="desktop-membership-banner--add-info-container">
        <InterPolationText banner={membershipDetails} />
        <div>
          <span
            className={`${
              onSale
                ? 'desktop-membership-banner--retail-price'
                : 'desktop-membership-banner--price'
            }`}
          >
            &#8377;{retailPrice}
          </span>
          {onSale && (
            <span className="desktop-membership-banner--price">
              &#8377;{salePrice}
            </span>
          )}
        </div>
      </div>

      <div className="desktop-membership-banner--add-info-button-container">
        {showChangePlan && (
          <div
            className="desktop-membership-banner--change-plan-text"
            onClick={() => showModal()}
          >
            {cta}
          </div>
        )}

        <Icon
          size={18}
          class="hb-prime-remove-icon desktop-membership-banner--icon-pointer"
          onClick={() => removeMembershipFromCart()}
        />
      </div>
    </>
  );
};

const MembershipBanner = ({
  containerStyle = '',
  showCartMembershipDetails = {},
  borderRadius = true,
  source = 'HOMEPAGE',
  showModal = () => {},
}) => {
  const { isMembershipAdded } = showCartMembershipDetails;
  const {
    hbPrimeStore: { membershipBannerDetail },
  } = useHBPrimeData();
  const {
    initialData: { launchInfo },
  } = useInitialData();

  const details = isMembershipAdded
    ? showCartMembershipDetails
    : membershipBannerDetail;

  const displayMembershipBanner = checkPrimeMemberShipSource(
    details?.bannerDisplayPages,
    source
  );

  if (!launchInfo?.displayPrime || !displayMembershipBanner) return null;

  return (
    <div className={containerStyle}>
      <div
        className={`desktop-membership-banner ${
          borderRadius ? 'border-radius' : ''
        }`}
      >
        <Icon class="icon-hb-prime-banner" size={40} />
        <div
          className={`desktop-membership-banner--sub-container ${
            showDetails[source]?.arrowAlignment
              ? 'desktop-membership-banner--arrow-alignment'
              : ''
          } `}
        >
          {isMembershipAdded ? (
            <MembershipAdded
              membershipDetails={details}
              showModal={showModal}
            />
          ) : (
            <MembershipInfo
              membershipDetails={details}
              showModal={showModal}
              source={source}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default MembershipBanner;
